// extracted by mini-css-extract-plugin
export default {"root":"SelectAlbumPopup__root--1bn8A","modal":"SelectAlbumPopup__modal--34QVR","title":"SelectAlbumPopup__title--esmvQ"};